import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { GetTagsResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: GetTagsResponse) => ReactElement
}

const GetAiTestConfigEnvironmentTagsRequest = ({
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/agents/tags`

  const { requestParams } = useGetParamsWithSpaceId({})

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      params={requestParams}
      url={url}
    />
  )
}

export default GetAiTestConfigEnvironmentTagsRequest
